import React from "react";

var ClipboardCheckIcon = function ClipboardCheckIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M20 4h-4a4 4 0 0 0-8 0H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8-2a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm3.832 10.168L11.277 19l-3.832-2.555a1 1 0 1 1 1.11-1.664l2.168 1.445 3.445-5.168a1 1 0 1 1 1.664 1.11z"
  }));
};

ClipboardCheckIcon.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
ClipboardCheckIcon.defaultProps.solid = true;
export default ClipboardCheckIcon;